module.exports = __webpack_public_path__ + "static/media/slide3.6b3c2737.jpg";